import { useEffect } from 'react';
import { stopTimer } from '../operators/stopTimer';
export function useMetricSuccessfulLoad(metricName) {
  useEffect(() => {
    stopTimer(metricName, 'success');
  });
}